import * as t from 'io-ts';

/*
 * Runtime type.
 */

export enum FileCacheItemTypesEnum {
  IMAGE = 'IMAGE',
  DOCUMENT = 'DOCUMENT',
}

const RFileCacheItemBase = t.type({
  key: t.string,
  uid: t.string,
  filename: t.string,
  mimeType: t.string,
  size: t.Integer,
  downloadDate: t.Integer,
  lastUseDate: t.Integer,
});

const RFileCacheImageItem = t.intersection([
  RFileCacheItemBase,
  t.type({
    type: t.literal(FileCacheItemTypesEnum.IMAGE),
    width: t.Integer,
    height: t.Integer,
  }),
]);

const RFileCacheDocumentItem = t.intersection([
  RFileCacheItemBase,
  t.type({
    type: t.literal(FileCacheItemTypesEnum.DOCUMENT),
  }),
]);

const RFileCacheItemDirty = t.taggedUnion('type', [RFileCacheImageItem, RFileCacheDocumentItem]);

/*
 * Type.
 */

export interface FileCacheImageItem extends Readonly<t.TypeOf<typeof RFileCacheImageItem>> {}
export interface FileCacheDocumentItem extends Readonly<t.TypeOf<typeof RFileCacheDocumentItem>> {}
export type FileCacheItem = FileCacheImageItem | FileCacheDocumentItem;
export const RFileCacheItem = t.clean<FileCacheItem>(RFileCacheItemDirty as any);
